export const APP_CONFIG = {
  apiBaseUrl: process.env.REACT_APP_API_BASE_URL || 'https://mundolandia.com/api',
};
